module.exports = __webpack_public_path__ + "img/i can cut pretty much anything.3b9dd0bb.png";